import { render } from "./inCome.vue?vue&type=template&id=458b8ff5&scoped=true"
import script from "./inCome.vue?vue&type=script&lang=js"
export * from "./inCome.vue?vue&type=script&lang=js"

import "./inCome.vue?vue&type=style&index=0&id=458b8ff5&lang=scss&scoped=true"

import exportComponent from "D:\\GProjects\\MsSaj\\pms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-458b8ff5"]])

export default __exports__